import { createAction, props } from '@ngrx/store';

export const historyParamsRequest = createAction('[History] Request History Params');
export const historyParamsUpdate = createAction('[History] Update History Params', props<any>());
